module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"image_cutout":"Image Cutout"},"ja":{"image_cutout":"FITS切り出し"}}')
  delete Component.options._Ctor
}
